<template>
    <div>
        <div class="bar"></div>
        <div class="tip">企业版的功能和权益将会不断扩充，首选推荐企业版四季度版本</div>
        <div class="white">
            <div class="whiteText1">您已提交企业版套件订单</div>
            <div class="whiteText2">我们正在审核您的订单申请，通过后会第一时间通知您完成订单</div>
            <div class="grey"></div>
            <div class="greyContent">
                <div class="greyText1">订单编号：</div>
                <div class="greyText2">{{id}}</div>
                <div class="greyText1" style="top: 96px;">下单时间：</div>
                <div class="greyText2" style="top: 96px;">{{time}}</div>
                <div class="greyText1" style="top: 146px;">套件版本：</div>
                <div class="greyText2" style="top: 146px;">{{suitVersion}}</div>
                <div class="greyText1" style="top: 196px;">订单价格：</div>
                <div class="greyText2" style="top: 196px;">￥ {{price}} </div>
                <div class="greyText1" style="top: 246px;">合同甲方名称：</div>
                <div class="greyText2" style="top: 246px;" v-if="change==0">{{contractName}} <span style="color: #3A3A3A;cursor: pointer;padding-left: 15px;" @click="change=1">修改</span></div>
                <div v-if="change==1">
                    <div class="greyInput">
                    <input
                    type="text"
                    class="inputContent"
                    id="inputContentId"
                    placeholder=""
                    @blur="isEmpty()"
                    @input="isEmpty()"
                />
                </div>
                <div class="greyText3" @click="changeName()">确定</div>
                <div class="greyText4" v-if="red==1">修改内容不能为空！</div>
                </div>
                <div class="greyButton" @click="isShadow=1">取消订单</div>
            </div>
        </div>
        <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText1">您取消订单的原因是</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="shadowIcon" v-if="reason!=1" @click="reasonSelect(1)">
                <img src="~@/assets/newHome/选中.png" alt="" class="shadowIcon" v-if="reason==1">
                <div class="shadowText2">信息填写错误，需要重填</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="shadowIcon"  style="top: 166px;" v-if="reason!=2" @click="reasonSelect(2)">
                <img src="~@/assets/newHome/选中.png" alt="" class="shadowIcon"  style="top: 166px;" v-if="reason==2">
                <div class="shadowText2"  style="top: 163px;">不知道怎么用</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="shadowIcon"  style="top: 208px;" v-if="reason!=3" @click="reasonSelect(3)">
                <img src="~@/assets/newHome/选中.png" alt="" class="shadowIcon"  style="top: 208px;" v-if="reason==3">
                <div class="shadowText2"  style="top: 205px;">价格因素</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="shadowIcon"  style="top: 250px;" v-if="reason!=4" @click="reasonSelect(4)">
                <img src="~@/assets/newHome/选中.png" alt="" class="shadowIcon"  style="top: 250px;" v-if="reason==4">
                <div class="shadowText2"  style="top: 247px;">其他原因</div>
                <div class="shadowOther" v-if="reason==4">
                    <input
                    type="text"
                    class="shadowOtherInput"
                    id="shadowOtherInputId"
                    placeholder=""
                />
                </div>
                <div class="shadowButton1" @click="isShadow=0">我再想想</div>
                <div class="shadowButton2" @click="cancelOrder()">取消订单</div>
            </div>
        </div>
        <div class="shadow" v-if="isShadow==2">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="$router.push('/');">
                <div class="shadowText3">您的订单已取消</div>
                <div class="shadowButton" @click="$router.push('/');"> 关闭 ({{second}}s)</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Process",
    data(){
        return{
            id:"",
            time:"",
            suitVersion:"",
            price:"",
            contractName:"北京航天世景信息技术有限公司",
            red:0,
            change:0,
            isShadow:0,
            reason:1,
            second: 5,
            timer:"",
        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        getOrderData(){
            let id = this.$route.query.id;
            var inputForm = new FormData();
            inputForm.append("id",id);
            this.axios.post("/tilesapi/tiles/register/queryTileOrderById", inputForm, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                })
                .then((res) => {
                    console.log(res)
                if(res.data.code==200){
                    this.id = id
                    let data = res.data.data
                    this.time = data.createTime
                    if(data.repositorySubName=="2023年全年"){
                        this.suitVersion = "企业版-2023年四季度版"
                    }else if(data.repositorySubName=="2023第一季度"){
                        this.suitVersion = "企业版-单季度版-2023第一季度"
                    }else if(data.repositorySubName=="2023第二季度"){
                        this.suitVersion = "企业版-单季度版-2023第二季度"
                    }else if(data.repositorySubName=="2023第三季度"){
                        this.suitVersion = "企业版-单季度版-2023第三季度"
                    }else if(data.repositorySubName=="2023第四季度"){
                        this.suitVersion = "企业版-单季度版-2023第四季度"
                    }else if(data.repositorySubName=="2024年全年"){
                        this.suitVersion = "企业版-2024年四季度版"
                    }else if(data.repositorySubName=="2024第一季度"){
                        this.suitVersion = "企业版-单季度版-2024第一季度"
                    }else if(data.repositorySubName=="2024第二季度"){
                        this.suitVersion = "企业版-单季度版-2024第二季度"
                    }
                    this.price = data.payFinal
                    this.contractName = data.userClientName
                    
                    
                }
            });

        },
        changeName(){
            let inputContentId = document.getElementById("inputContentId");
            if(inputContentId.value!=''&&inputContentId.value!=null){
                var userInfo = {
                    id: this.id,
                    userClientName: inputContentId.value,
                };
                this.axios.post("/tilesapi/tiles/contract/editUserClientName",userInfo, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    if(res.data.code==200){
                        console.log("修改合同成功")
                        this.contractName=inputContentId.value
                        this.change=0
                    }else{
                        alert("修改失败")
                    }
                     
                })
                
            }

        },
        isEmpty(){
            let inputContentId = document.getElementById("inputContentId");
            if(inputContentId.value==''||inputContentId.value==null){
                this.red=1
            }else{
                this.red=0
            }
        },
        cancelOrder(){
            let input = ""
            let shadowOtherInputId = document.getElementById("shadowOtherInputId");
            if(shadowOtherInputId!=null&&shadowOtherInputId!=''&&shadowOtherInputId!=undefined){
                input=shadowOtherInputId.value
            }
            var userInfo = {
                id: this.id,
                reasonType:this.reason - 1,
                reasonContent: input,
            };
            this.axios.post("/tilesapi/tiles/register/cancelTileOrder",userInfo, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    console.log(res)
                    if(res.data.code==200){
                        this.isShadow=2
                        this.daojishiOn()
                    }else{
                        alert("取消失败")
                    }
                    
                })
        },
        reasonSelect(i){
            this.reason=i
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        daojishiOn(){
            this.$nextTick(() => {
            this.timer = setInterval(this.daojishi, 1000);
        });
        },
        daojishi(){
            if(this.second<=0){
                this.$router.push("/");
                clearInterval(this.timer);
            }else{
                this.second--
            }
        },
    },
    mounted(){
        this.toPageTop()
        this.getOrderData()
    }

}
</script>

<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.tip{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #F5F5F6;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 76px;
    text-align: center;
}
.white{
    position: relative;
    width: 1280px;
    height: 1000px;
    margin-left: calc(50% - 640px);
    background-color: #fff;
    
}
.whiteText1{
    position: absolute;
    top: 75px;
    width: 500px;
    left:calc(50% - 250px);
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.whiteText2{
    position: absolute;
    top: 142px;
    left:calc(50% - 400px);
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.grey{
    position: absolute;
    top: 214px;
    width: 1280px;
    height: 400px;
    background: rgba(245,245,246,0.1);
    opacity: 0.15;
    border-radius: 16px;
}
.greyContent{
    position: absolute;
    top: 214px;
    width: 1280px;
    height: 400px;
    background: transparent;
    border-radius: 16px;
}
.greyText1{
    position: absolute;
    top: 46px;
    right: 1065px;
    width: 200px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    text-align: right;

}
.greyText2{
    position: absolute;
    top: 46px;
    left: 225px;
    width: 768px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 30px;
}
.greyInput{
    position: absolute;
    top: 241px;
    left: 225px;
    width: 800px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.greyText3{
    position: absolute;
    top: 250px;
    right: 213px;
    width: 40px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: right;
    cursor: pointer;
}
.greyText4{
position: absolute;
top: 286px;
    left: 225px;
    width: 768px;
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: red;
    line-height: 30px;
}
.greyButton{
    position: absolute;
    top: 324px;
    right: 52px;
    width: 128px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3A3A3A;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.inputContent{
    top: 5px;
    left: 5px;
  position: absolute;
  width: 768px;
height: 30px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3a3a3a;
line-height: 30px;  
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 150px);
    left: calc(50% - 400px);
    width: 800px;
    height: 300px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowButton{
    position: absolute;
    top: 175px;
    left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #3A3A3A;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 40px;
    text-align: center;
}
.shadowText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 400px);
    width: 800px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.shadowIcon{
    position: absolute;
    top: 124px;
    left: 90px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.shadowText2{
    position: absolute;
    top: 121px;
    left: 118px;
    width: 700px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 22px;
}
.shadowText3{
    position: absolute;
    top: 100px;
    left: calc(50% - 400px);
    width: 800px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;
}
.shadowOther{
    position: absolute;
    top: 239px;
    left: 194px;
    width: 500px;
height: 40px;
background: #FFFFFF;
border-radius: 6px;
border: 1px solid #979797;
}
.shadowOtherInput{
    top: 5px;
    left: 5px;
  position: absolute;
  width: 450px;
height: 30px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000;
line-height: 30px;  
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.shadowButton1{
    position: absolute;
    top: 307px;
    left: 244px;
    width: 150px;
    height: 40px;
    background: #1E81EB;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    }
    .shadowButton2{
        position: absolute;
        top: 307px;
        left: 406px;
        width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #1E81EB;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #1E81EB;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    }
</style>